import { Button, Input, Option, Select } from '@material-tailwind/react'
import React, { useState, useEffect } from 'react'
import AIcon from '../partials/AIcon'
import AInput from './AInput'
import { useForm, Controller, useFieldArray } from 'react-hook-form';
export default function ItemsComp({ v }) {
    const { fields, append, remove } = useFieldArray({
        control: v.control,
        name: v.items
    });

    useEffect(() => {
        if (fields?.length === 0) appendFieldArrayData()
    }, [])

    const appendFieldArrayData = () => {
        append({ ...v.data?.items?.fields })
    }

    const clName = () => ({ className: "!min-w-[10rem]" })

    const getOBJKeys = (obj) => Object.keys(obj)

    console.log("object keys", getOBJKeys(v.data?.items?.fields));



    return (
        <fieldset className= {`border border-solid border-gray-300 px-2 py-1 rounded-md ${v.data?.className}`}>
            <legend className={`text-base text-black font-semibold amiriB ${v.className}`}>{v.data?.label}</legend>
            <div className='overflow-auto grid grid-cols-1 '>


                <table className=' w-full border-separate border-spacing-2  border-slate-400'>
                    <thead>
                        <tr className='amiriB'>
                            {v.data?.items?.head?.map((h, i) => (<th key={i}>{h}</th>))}
                            {fields.length > 1 && <td></td>}
                        </tr>
                    </thead>
                    <tbody>
                        {fields.map((o, i) => {
                            return (

                                <tr key={i} className="relative">
                                    <td className='w-[4%]'> <span className='border-2 rounded-md  border-slate-300 text-center p-2'>{i + 1}</span> </td>
                                    {getOBJKeys(v.data?.items?.fields).map((f, j) => {
                                        return <td key={j} >

                                            {f !== 'currency' ? <Input containerProps={clName()}
                                                {...v?.register(`items.${i}.${f}`)} color="teal"
                                                labelProps={{
                                                    className: 'before:content-none',
                                                }} />
                                                : <select  {...v?.register(`items.${i}.${f}`)}
                                                className="h-[39px] w-24 border-2 border-gray-400 rounded-md focus-visible:!border-green-700 focus-visible:outline-green-700"
                                                >
                                                    <option>AFN</option>
                                                    <option>USD</option>
                                                    <option>EUR</option>
                                                    <option>AED</option>
                                                    <option>GBP</option>
                                                    <option>CHF</option>
                                                </select>
                                            }
                                        </td>
                                    })}
                                    {i > 0 && <td className='w-[4%]' onClick={() => remove(i)}> <Button className='btn1 p-1 !bg-red-900 rounded-full'  ><AIcon name="close" size={15} /> </Button> </td>}

                                </tr>

                            )
                        })

                        }
                    </tbody>
                </table>
            </div>


            <Button variant="outlined" onClick={appendFieldArrayData} className='btn1 py-0.5 px-1  float-right mt-1 !bg-green-500  rounded-full'  ><AIcon name="add-circle-outline" size={20} className="text-white" /></Button>
        </fieldset>
    )
}
